/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCsrfToken200Response
 */
export interface GetCsrfToken200Response {
    /**
     * 
     * @type {string}
     * @memberof GetCsrfToken200Response
     */
    csrfToken: string;
}

/**
 * Check if a given object implements the GetCsrfToken200Response interface.
 */
export function instanceOfGetCsrfToken200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "csrfToken" in value;

    return isInstance;
}

export function GetCsrfToken200ResponseFromJSON(json: any): GetCsrfToken200Response {
    return GetCsrfToken200ResponseFromJSONTyped(json, false);
}

export function GetCsrfToken200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCsrfToken200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'csrfToken': json['csrfToken'],
    };
}

export function GetCsrfToken200ResponseToJSON(value?: GetCsrfToken200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'csrfToken': value.csrfToken,
    };
}

